import vue from 'vue'
import diaLogin from './dialogin.vue'

// 组件构造器，构造出一个 vue组件实例
const DiaLoginConstructor = vue.extend(diaLogin)

function showDiaLogin() {
  const dialoginDom = new DiaLoginConstructor({
    el: document.createElement('div'),
    data() {
      return {
        showDiaLogin: true,
      }
    }
  })
  // 添加节点
  document.body.appendChild(dialoginDom.$el)
}
// 全局注册
function registryDiaLogin() {
  vue.prototype.$dialogin = showDiaLogin
}

export default registryDiaLogin